import TechItem from '../../common/TechItem'
import { useEffect } from 'react'
import '../../Technology.css'

const Cosital18 = () => {

    useEffect(() => {
        document.title = 'Séneca retransmite el Congreso COSITAL 2018 celebrado en Gijón'
        window.scrollTo(0, 0)
    }, []);

    return (

        <TechItem
            title={'Séneca retransmite el Congreso COSITAL 2018 celebrado en Gijón'}
            imageURL={'/images/technology/tecnologia-3.jpg'}
            date={'18 mayo, 2018'}
            textArray={[
                "<p className='middle-section-label'>Durante los días 10, 11 y 12 de mayo se celebró en el Palacio de Congresos de Gijón el Congreso bienal COSITAL 2018 y la XII Asamblea Plenaria del colectivo bajo el lema “Secretarios, Interventores y Tesoreros de administración local: Integridad, legalidad, y transparencia al servicio de la democracia”. Como no podía se ser de otro modo, la grabación y retransmisión de las jornadas se realizó a través de nuestro software Séneca.</p>",
                "<p className='middle-section-label'>Todas las mesas fueron grabadas y catalogadas por nuestro equipo y pueden visualizarse en la mediateca que COSITAL tiene con nuestro sistema para añadir y tener bien organizados todos sus contenidos audiovisuales. Como parte del servicio que ofrece Séneca, todos los actos y jornadas fueron retransmitidos en directo a través del canal de streaming con el que cuenta la mediateca.</p>",
                "<section className='padding-only' />",
                "<h3 className='seneca-blue'>Aquí podéis ver algunas imágenes de nuestro equipo durante la grabación</h3>",
                "<section className='flex gap-20 wrap'><img loading='lazy' alt='Imagen' src='/images/technology/cosital/cosital-1.jpg' className='blog-image-medium'></img><img loading='lazy' alt='Imagen' src='/images/technology/cosital/cosital-2.jpg' className='blog-image-medium'></img><img loading='lazy' alt='Imagen' src='/images/technology/cosital/cosital-3.jpg' className='blog-image-medium'></img><img loading='lazy' alt='Imagen' src='/images/technology/cosital/cosital-4.jpg' className='blog-image-medium'></img><img loading='lazy' alt='Imagen' src='/images/technology/cosital/cosital-5.jpg' className='blog-image-medium'></img></section>"
            ]}
        />

    )
}

export default Cosital18